var NewPasswordValidate = $.extend({/* NewPasswordValidate */}, BaseComponent, {

	componentSelector: '#set-new-password',

	init: function() {
		$(this.componentSelector).each(this.binding.bind(this));
	},

	binding: function(index, element) {

		$(element).validate({
			rules: {
				currentpassword: {
					required: true,
					minlength : 6,
					maxlength: 6,
					pattern: /^([a-zA-Z0-9]+)$/
				},
				newpassword : {
					required: true,
					minlength : 6,
					maxlength: 6,
					pattern: /^([a-zA-Z0-9]+)$/
				},
				repeatpassword : {
					required: true,
					minlength : 6,
					maxlength: 6,
					equalTo : '#newpassword',
					pattern: /^([a-zA-Z0-9]+)$/
				}
			},
			submitHandler: function(form) {
				form.submit();
			},
            errorPlacement: function (error, element) {
				error.insertAfter(element);
            }
		});

		$(element).find('#new-password-submit').click((function(event) {
			event.preventDefault();
			$(element).submit();
		}).bind(this));
	}
})